module.exports = __webpack_public_path__ + "static/media/18_shape_l.813a1ed8.webp";